<template>
	<div>
		<b-breadcrumb class="flex-nowrap m-0" :items="breadcrumbs"/>
		<transition name="slide-left-only" appear>
			<div class="w-100">
				<div class="row m-3">
					<!-- <div class="col-12 col-sm-12 col-lg-6 col-xl-4">
						<card-field-component
						type="select"
						title="Параметр"
						fieldname="indicator"
						v-model="indicator"
						:display-value="indicator"
						:disabled="isLoading"
						:mode="'edit'"
						:options="option_groups"
						v-on:update:value="indicator = $event;"
						:is-required="true"
						/>
					</div> -->
					<div class="col-12 col-sm-6 col-lg-3 col-xl-2">
						<card-field-component
						type="date"
						class="mb-3"
						title="Выберите год"
						:year-only="true"
						fieldname="start_date"
						v-model="start_date"
						:display-value="start_date"
						:disabled="isLoading"
						:mode="'edit'"
						v-on:update:value="start_date = $event; report = null"
						:is-required="true"
						:options="{
							disabledDates:{
								from: end_date ? new Date(end_date) : null
							}
						}"
						/>
					</div>
					<div class="col-12 col-sm-6 col-lg-3 col-xl-2">
						<card-field-component
						type="date"
						class="mb-3"
						title="Выберите год"
						:year-only="true"
						fieldname="end_date"
						v-model="end_date"
						:display-value="end_date"
						:disabled="isLoading"
						:mode="'edit'"
						v-on:update:value="end_date = $event; report = null"
						:is-required="true"
						:options="{
							disabledDates:{
								to: start_date ? new Date(start_date) : null
							}
						}"
						/>
					</div>
				</div>
				<div class="row m-3" >
					<div class="col-12">
						<!-- <b-button
						@click.prevent="fetchData"
						variant="primary"
						class="mb-3 mr-2"
						size="sm"
						:disabled="isLoading || !start_date || !end_date"
						>
							Получить
						</b-button> -->
						<b-button
						@click.prevent="downloadFile"
						:disabled="isLoading || !start_date || !end_date"
						variant="success"
						class="mb-3"
						size="sm"
						>
							Скачать таблицу
						</b-button>
					</div>
				</div>
				<!-- <div class="d-inline-flex p-2">
					<div v-if="isLoading && !report" class="p-3">
						<loading-panel loading-text="Загружается отчет"/>
					</div>
					<table v-else-if="report" class="table table-bordered table-responsive report-table bg-white shadow-sm" :class="isLoading ? 'opacity-50' : ''">
						<thead class="small-text bg-light">
							<tr v-if="title">
								<td colspan="3"> {{ title }} </td>
							</tr>
							<tr>
								<td> Территориальное управление</td>
								<td> {{ moment(start_date).format('YYYY') }} г.</td>
								<td> {{ moment(end_date).format('YYYY') }} г.</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, iIndex) in report">
									<td>{{ iIndex }}</td>
								<template v-for="i in item">
									<td>{{ i.indicator }}</td>
								</template>
							</tr>
						</tbody>
					</table>
				</div> -->
			</div>
		</transition>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	name: 'knd01_with_appg_full',
	props: [],
	data () {
		return {
			moment: moment,
			start_date: null,
			end_date: null,
			// indicator: null,
			isLoading: false,
			report: null,
			title: null,
			error: null,
			// option_groups: null,
			breadcrumbs: [
				{
					text: 'Главная',
					to: '/'
				},
				{
					text: 'Статистика и отчеты',
					to: '/reports'
				},
				{
					text: 'КНД: Отчет по форме №1 с АППГ по всем ТУ и всем показателям',
					active: true
				}
			]
		}
	},
	computed: {
		url () {
			return process.env.VUE_APP_API_ROOT + '/api/reports/knd01_with_appg_full?start_date=' + this.start_date + '&end_date=' + this.end_date
		},
	},
	methods: {
		// getOptions() {
		// 	let optUrl = process.env.VUE_APP_API_ROOT + '/api/reports/knd01_with_appg_single?get_option_groups'

		// 	this.$http.get(optUrl)
		// 		.then(res => {
		// 			this.option_groups = res.data.option_groups
		// 		})
		// 		.catch(error => {
		// 			this.$notify({
		// 				group: 'main',
		// 				text: 'Ошибка: ' + (error.response.data.error ? error.response.data.error : error.message),
		// 				duration: 3000,
		// 				type: 'alert-danger'
		// 			})
		// 		})
		// 		.then(() => {
		// 			this.isLoading = false
		// 		})
		// },
		fetchData (doDownload = false) {
			if (this.isLoading) {
				return false
			}

			this.isLoading = true
			this.report = null

			this.$http.get(this.url)
				.then(res => {
					this.report = res.data.report
					// this.title = res.data.title
				})
				.catch(error => {
					this.$notify({
						group: 'main',
						text: 'Ошибка: ' + (error.response.data.error ? error.response.data.error : error.message),
						duration: 3000,
						type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		},
		downloadFile () {
			if (this.isLoading) {
				return false
			}

			this.isLoading = true
			this.$http
				.get(this.url + '&export=1', {
					responseType: 'blob'
				})
				.then(response => {
					this.$notify({
						group: 'main',
						text: 'Экспорт готов! Файл начал скачиваться',
						duration: 3000,
						type: 'alert-success'
					})
					const filename = 'отчет_полный_форма_01_аппг.xlsx'
					let blob = new Blob([response.data], {
						type: 'application/octet-stream',
					})
					if (typeof window.navigator.msSaveBlob !== 'undefined') {
						window.navigator.msSaveBlob(blob, filename);
					} else {
						let blobURL = window.URL.createObjectURL(blob);
						let tempLink = document.createElement('a');
						tempLink.style.display = 'none';
						tempLink.href = blobURL;
						tempLink.download = filename;
						tempLink.click();
						window.URL.revokeObjectURL(blobURL);
					}
				})
				.catch(error => {
					this.$notify({
						group: 'main',
						text: 'Ошибка скачивания файла',
						duration: 3000,
						type: 'alert-danger'
					})
				})
				.then(() => {
					this.isLoading = false
				})
		}
	}
}
</script>
